var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { EMPTY_TITLE_VERIFICATION_FILTERS, isAnyTitleVerificationFilterActive, parseTitleVerificationFilters, toTitleVerificationUrlSearch, } from "../utils/titleVerificationFilters";
export var useTitleVerificationFilters = function (type) {
    var history = useHistory();
    var location = useLocation();
    var _a = useState(EMPTY_TITLE_VERIFICATION_FILTERS), filters = _a[0], setFilters = _a[1];
    var _b = useState(EMPTY_TITLE_VERIFICATION_FILTERS), appliedFilters = _b[0], setAppliedFilters = _b[1];
    var handleFilterChange = function (field, value) {
        var _a;
        var newFilters = __assign(__assign({}, filters), (_a = {}, _a[field] = value, _a));
        setFilters(newFilters);
    };
    var handleProvisionalChange = function (provisional) {
        setFilters(__assign(__assign({}, filters), { provisional: provisional }));
    };
    var handleApplyFilters = function () {
        setAppliedFilters(filters);
        history.push({ search: toTitleVerificationUrlSearch(filters, type) });
    };
    var handleClearFilters = function () {
        setFilters(EMPTY_TITLE_VERIFICATION_FILTERS);
        setAppliedFilters(EMPTY_TITLE_VERIFICATION_FILTERS);
        history.push({ search: "" });
    };
    var isAnyFilterActive = function () {
        return isAnyTitleVerificationFilterActive(appliedFilters, type);
    };
    var hasUnappliedChanges = function () {
        return JSON.stringify(filters) !== JSON.stringify(appliedFilters);
    };
    useEffect(function () {
        var newFilters = parseTitleVerificationFilters(location.search, type);
        if (JSON.stringify(newFilters) !== JSON.stringify(appliedFilters)) {
            setFilters(newFilters);
            setAppliedFilters(newFilters);
        }
    }, [location.search, type]);
    return {
        filters: filters,
        appliedFilters: appliedFilters,
        handleFilterChange: handleFilterChange,
        handleProvisionalChange: handleProvisionalChange,
        handleApplyFilters: handleApplyFilters,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
        hasUnappliedChanges: hasUnappliedChanges,
    };
};
